export default __webpack_public_path__ + "static/media/safebox.95d1eca7.png";